import o from "../../node_modules/classnames/index.js";
import "./formGrid2.js";
import { jsx as a } from "../../_virtual/jsx-runtime.js";
function f({
  children: m,
  size: r = "medium",
  disableHorizontalGutter: i
}) {
  return /* @__PURE__ */ a("div", {
    "data-disable-horizontal-gutter": i,
    className: o("form-grid", {
      "form-grid--medium": r === "medium",
      "form-grid--large": r === "large"
    }),
    children: m
  });
}
export {
  f as FormGrid
};
//# sourceMappingURL=FormGrid.js.map
